import { render } from "./0_head.vue?vue&type=template&id=07dc5e94&ts=true"
import script from "./0_head.vue?vue&type=script&lang=ts"
export * from "./0_head.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__